// extracted by mini-css-extract-plugin
module.exports = {"image":"image-module__image___7yXa2","image-placeholder":"image-module__image-placeholder___1QQOV","imagePlaceholder":"image-module__image-placeholder___1QQOV"};